"use client";

type FutureJobsHeadingProps = {
  variant: "fallback" | "inline";
  centered?: boolean;
};

export default function FutureJobsHeading({
  variant,
  centered = false,
}: FutureJobsHeadingProps) {
  const text =
    variant === "fallback"
      ? "Ou registre seu interesse em vagas futuras nos departamentos abaixo:"
      : "Não encontrou a sua vaga? registre seu interesse em vagas futuras nos departamentos abaixo:";

  return (
    <div className={`pt-3 pb-3 ${centered ? " text-center" : ""}`}>
      <p
        className={`text-[21px] leading-[32px] font-semibold text-text-primary${centered ? " mx-auto" : ""} max-w-[838px]`}
      >
        {text}
      </p>
    </div>
  );
}
